/**
 * PaymentErrorBanner — Shows an alert when the payment is in FAILED state.
 */
import Alert from '@cloudscape-design/components/alert';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { useAppSelector } from 'src/store/hooks';

export const PaymentErrorBanner = () => {
  const payment = useAppSelector(state => state.payment.data);
  if (!payment) return null;

  // Check for FAILED entries in the timeline
  const failures = payment.statusTimeline.filter(entry => entry.state === 'FAILED');
  if (failures.length === 0) return null;

  return (
    <Alert type="error" header={`${failures.length} error${failures.length > 1 ? 's' : ''} detected`}>
      <SpaceBetween size="xs">
        {failures.map((f, i) => (
          <Box key={i} fontSize="body-s">
            <Box fontWeight="bold" variant="span">{f.status.replace(/_/g, ' ')}</Box>
            {f.phaseDetails && ` — ${f.phaseDetails}`}
          </Box>
        ))}
      </SpaceBetween>
    </Alert>
  );
};
